import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { createProductSearchOptions } from "~/config/searchProductConfig";
import NavSearchInput from "~/features/navbar/NavSearchInput";

import { searchProduct } from "~/lib/helpers";

import { setSearch, setSelectedSku } from "./orderCreation.slice";

type BinOrProductResult = {
  type: "bin" | "product";
  variantId?: Guid;
  binId?: Guid;
  sku?: string;
  displayText: string;
};

export function OrderCreationSearch() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const searchPlaceholder = t("search products");

  const searchText = useAppSelector((state) => state.orderCreation.search);

  const [autocompleteOptions, updateAutocompleteOptions] = useState<
    BinOrProductResult[]
  >([] as BinOrProductResult[]);

  const autocompleteSearchProducts = async (
    input: string | null
  ): Promise<void> => {
    if (!input) {
      return;
    }
    if (input.length) {
      const hits = await searchProduct(input);

      const hitsAsAutocompleteRecords = createProductSearchOptions({ hits });
      updateAutocompleteOptions([...hitsAsAutocompleteRecords]);
    }
  };

  return (
    <NavSearchInput<BinOrProductResult>
      setTextInput={(text) => dispatch(setSearch(text))}
      textInput={searchText || ""}
      isAutocomplete
      searchPlaceholder={searchPlaceholder}
      autocompleteSearchCb={(input) => {
        void autocompleteSearchProducts(input);
      }}
      autocompleteOptions={autocompleteOptions}
      autocompleteLabelConstructor={(option: BinOrProductResult): string =>
        option.displayText
      }
      groupBy={(option) => t(option.type)}
      selectCb={(result: BinOrProductResult) => {
        if (result.sku) {
          dispatch(setSelectedSku(result.sku));
        }
      }}
    />
  );
}
